import StoreBadgesGrid from '@/components/StoreBadgesGrid'
import { STRINGS } from '@/constants'
import { handoffToApp } from '@/utils/openApp'

const CTX = 'DownloadConnexaButton'

interface Props {
  accessToken: string
}

const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent)
const isAndroid = /Android/.test(navigator.userAgent)
const isMobile = isIOS || isAndroid

/**
 * Primary CTA on the profile-access page. On mobile shows a single "Download
 * Connexa" button that attempts app handoff (via the profile deep link) and
 * falls back to the platform's store. On desktop falls back to the universal
 * store-badge grid — cross-device handoff cannot work in a desktop browser.
 */
export default function DownloadConnexaButton({ accessToken }: Props) {
  const handleMobileClick = () =>
    handoffToApp({
      deepLink: `connexa://profile/${accessToken}`,
      isIOS,
      ctx: CTX,
    })

  if (isMobile) {
    return (
      <button onClick={handleMobileClick} className="btn btn-primary">
        {STRINGS.profile.downloadCta}
      </button>
    )
  }

  return <StoreBadgesGrid />
}
